import Immutable from 'immutable'
import moment from 'moment'

const fields = {
  dateAdded: null,
  dateUpdated: null,
  id: null,
  toEmail: null,
  toName: null,
}

export default class SignupStateTransitionNotification extends Immutable.Record(fields) {
  constructor({
    dateAdded,
    dateUpdated,
    to_email: toEmail,
    to_name: toName,
    ...data
  }) {
    super({
      dateAdded: dateAdded ? moment(dateAdded) : null,
      dateUpdated: dateUpdated ? moment(dateUpdated) : null,
      toEmail,
      toName,
      ...data,
    })
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/SignupStateTransitionNotification.js